export enum SEATS_COLUMNS {
    tableNumber = 'Table Number',
    seatNumber = 'Seat Number',
    seatName = 'Seat Name',
}
